module.exports = __webpack_public_path__ + "img/homepage-0-bg.20d16faa.jpg";